import React from 'react';
import { Nav } from 'react-bootstrap';
import { CustomNavLink } from '@ui/components/atoms';
import { Translations } from '@translations/translationsTypes';
import { useTranslate } from '@translations/useTranslate';
import NavbarNavStyles from './CustomNavbarNav.module.scss';

type Props = {
  links: { title: string; titleAr: string; link: string; linkAr: string }[];
};

export const CustomNavbarNav: React.FC<Props> = ({ links }) => {
  const { setLanguage, language } = useTranslate();
  return (
    <div className={NavbarNavStyles.navbar_nav}>
      <Nav className={NavbarNavStyles.navbar_nav__container}>
        {links.map((link, index) => (
          <CustomNavLink
            key={`header-link-${index}`}
            title={language === Translations.ar ? link.titleAr : link.title}
            link={language === Translations.ar ? link.linkAr : link.link}
          />
        ))}
        <div
          className={`${NavbarNavStyles.navbar_nav__lang_container} d-flex align-items-center set m-0`}
        >
          <div className="justify-content-center align-items-center m-0 d-flex">
            <button
              className="btn text-light p-0"
              style={{ fontSize: '14px' }}
              onClick={() => {
                setLanguage(Translations.en);
                window.location.reload();
              }}
            >
              EN
            </button>
            <span className="px-1">|</span>
            <button
              className="btn text-light p-0"
              style={{ fontSize: '14px' }}
              onClick={() => {
                setLanguage(Translations.ar);
                window.location.reload();
              }}
            >
              AR
            </button>
          </div>
        </div>
      </Nav>
    </div>
  );
};
